var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Message",

    getDefaultProps () {
        return {"className":"dibsvg-svg dibsvg-message","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"]]","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M235.5,8.9h-221C6.5,8.9,0,15.4,0,23.3v151.6c0,8,6.5,14.5,14.5,14.5h111.8l60.3,51c0.8,0.7,1.9,1.1,2.9,1.1 c0.6,0,1.3-0.1,1.9-0.4c1.6-0.7,2.6-2.3,2.6-4.1l0-47.6h41.6c8,0,14.5-6.5,14.5-14.5V23.3C250,15.4,243.5,8.9,235.5,8.9z M241,174.9 c0,3-2.5,5.5-5.5,5.5H185v9h0l0,37.9l-55.5-47l-0.1,0.2l-0.1-0.1H14.5c-3,0-5.5-2.5-5.5-5.5V23.3c0-3,2.5-5.5,5.5-5.5h221 c3,0,5.5,2.5,5.5,5.5V174.9z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/message.svg